import React from 'react';
import {
  Paper,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel
} from '@mui/material';
import { Search } from '@mui/icons-material';

/**
 * PartsCatalogFilters Component
 * Handles all filtering UI for the Parts Catalog
 */
const PartsCatalogFilters = ({
  searchTerm,
  setSearchTerm,
  filters,
  setFilters,
  showArchived,
  setShowArchived,
  dropdownOptions
}) => {
  return (
    <Paper sx={{ p: 2, mb: 2 }}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} md={3}>
          <TextField
            fullWidth
            size="small"
            label="Search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: <Search sx={{ mr: 1, color: 'text.secondary' }} />
            }}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <FormControl fullWidth size="small" sx={{ minWidth: 200 }}>
            <InputLabel
              sx={{
                fontSize: '14px',
                fontWeight: 600,
                color: 'text.primary',
                backgroundColor: 'background.paper',
                padding: '0 4px',
                whiteSpace: 'nowrap',
                overflow: 'visible',
                '&.MuiInputLabel-shrink': {
                  fontSize: '14px',
                  fontWeight: 600,
                  transform: 'translate(14px, -9px) scale(0.75)',
                  backgroundColor: 'background.paper',
                  padding: '0 4px',
                  color: 'text.primary',
                },
                '&.Mui-focused': {
                  color: 'primary.main',
                  fontWeight: 600,
                },
                '&.MuiInputLabel-root': {
                  zIndex: 1,
                },
              }}
            >
              Category
            </InputLabel>
            <Select
              value={filters.category}
              label="Category"
              onChange={(e) => setFilters({ ...filters, category: e.target.value })}
              sx={{
                '& .MuiOutlinedInput-notchedOutline': {
                  overflow: 'visible',
                },
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    maxHeight: 400,
                    minWidth: 350,
                    '& .MuiMenuItem-root': {
                      whiteSpace: 'normal',
                      wordBreak: 'break-word',
                      padding: '10px 16px',
                      minHeight: 'auto',
                      lineHeight: 1.5,
                      overflow: 'visible',
                    },
                  },
                },
              }}
            >
              <MenuItem value="">All</MenuItem>
              {dropdownOptions.categories.map((cat) => (
                <MenuItem key={cat._id} value={cat._id}>
                  {cat.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={3}>
          <FormControl fullWidth size="small" sx={{ minWidth: 200 }}>
            <InputLabel
              sx={{
                fontSize: '14px',
                fontWeight: 600,
                color: 'text.primary',
                backgroundColor: 'background.paper',
                padding: '0 4px',
                whiteSpace: 'nowrap',
                overflow: 'visible',
                '&.MuiInputLabel-shrink': {
                  fontSize: '14px',
                  fontWeight: 600,
                  transform: 'translate(14px, -9px) scale(0.75)',
                  backgroundColor: 'background.paper',
                  padding: '0 4px',
                  color: 'text.primary',
                },
                '&.Mui-focused': {
                  color: 'primary.main',
                  fontWeight: 600,
                },
                '&.MuiInputLabel-root': {
                  zIndex: 1,
                },
              }}
            >
              Manufacturer
            </InputLabel>
            <Select
              value={filters.manufacturer}
              label="Manufacturer"
              onChange={(e) => setFilters({ ...filters, manufacturer: e.target.value })}
              sx={{
                '& .MuiOutlinedInput-notchedOutline': {
                  overflow: 'visible',
                },
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    maxHeight: 400,
                    minWidth: 350,
                    '& .MuiMenuItem-root': {
                      whiteSpace: 'normal',
                      wordBreak: 'break-word',
                      padding: '10px 16px',
                      minHeight: 'auto',
                      lineHeight: 1.5,
                      overflow: 'visible',
                    },
                  },
                },
              }}
            >
              <MenuItem value="">All</MenuItem>
              {dropdownOptions.manufacturerNames.map((mn) => (
                <MenuItem key={mn._id} value={mn._id}>
                  {mn.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={3}>
          <FormControlLabel
            control={
              <Checkbox
                checked={showArchived}
                onChange={(e) => setShowArchived(e.target.checked)}
                size="small"
              />
            }
            label="Show Archived"
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default PartsCatalogFilters;
